import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    button: {
        position: 'absolute',
        top: '24px',
        right: '70px',

        color: 'white',
    },
    icon: {
        width: theme.spacing(4),
        height: '26px',
        marginRight: theme.spacing(3),
        padding: 0,

        fontSize: '18px',
        fontWeight: 'bold',
    },
    text: {
        lineHeight: 2,
    },
}));
